import React from 'react';

import { Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';

import './MarketingFooter.scss';

export function MarketingFooter() {
	return (
		<footer className="marketing-footer">
			<Paragraph
				color="white"
				weight="standard"
				last
			>
				&copy; {new Date().getFullYear()} SpareFoot.com All rights reserved.{' '}
				<span>
					<Link
						href="/legal/consumer.html"
						rel="nofollow"
						color="white"
						weight="standard"
						hideBorder
					>
						Terms of Service
					</Link>
					{' '}and{' '}
					<Link
						href="/legal/privacy.html"
						color="white"
						weight="standard"
						hideBorder
					>
						Privacy Policy
					</Link>.
				</span>
			</Paragraph>
		</footer>
	);
}

export default MarketingFooter;
